var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.error)?_c('figure',{class:`icon ${_vm.name}-icon`},[_c('InlineSvg',{attrs:{"src":`/static/svg/${_vm.name}.svg`},on:{"error":function($event){_vm.error = true}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }